import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

const DEFAULT_PER_PAGE = 500;
const CUSTOM_OFFERS_STALE_TIME_MS = 60_000;

export const customOfferQueryKeys = {
  all: ['custom-offers'] as const,
  customerOffers: (customerId: string, perPage: number) =>
    [...customOfferQueryKeys.all, 'customer-offers', customerId, perPage] as const,
};

export function useGetCustomOffers(customerId: string, enabled: boolean, perPage = DEFAULT_PER_PAGE) {
  return useQuery({
    queryKey: customOfferQueryKeys.customerOffers(customerId, perPage),
    queryFn: () => OffersService.getCustomOffers({ customerId, page: 1, perPage }),
    enabled,
    staleTime: CUSTOM_OFFERS_STALE_TIME_MS,
  });
}
